<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-3">
      <div class="d-flex flex-column">
        <span class="font-size-15 font-weight-bold d-block">
          Маски реєстраційного номера
        </span>
        <span class="text-disabled">
          Шаблони автоматичної нумерації документів
        </span>
      </div>
      <v-btn @click="createMask">
        <v-icon class="mr-1">mdi-plus</v-icon>
        Додати маску
      </v-btn>
    </div>
    <v-card
      v-if="
        journalSource.maskName &&
        journalSource.numberMask &&
        journalSource.numberMaskPreview
      "
      border>
      <v-card-text>
        <div class="d-flex align-center justify-space-between mb-3">
          <span class="font-size-14 font-weight-bold d-block">
            {{ journalSource.maskName }}
          </span>
          <v-btn
            :loading="$loading.isLoading('registrationJournalMaskDelete')"
            border
            class="text-none"
            size="small"
            style="border-color: #ddd"
            variant="outlined"
            @click="deleteMask">
            <span class="font-weight-medium text-error"> Видалити </span>
          </v-btn>
        </div>
        <div class="d-flex flex-column ga-1">
          <span class="text-disabled">
            {{ journalSource.maskDescription || 'Опис відсутній' }}
          </span>
          <div class="d-flex align-center ga-2">
            <span class="font-weight-bold text-grey font-size-11">
              НУМЕРАЦІЯ:
            </span>
            <v-chip color="grey" density="compact" rounded="lg">
              <span class="font-size-14 font-weight-bold text-black">
                {{ journalSource.numberMask || '---' }}
              </span>
            </v-chip>
          </div>
          <div class="d-flex align-center ga-2">
            <span class="font-weight-bold text-grey font-size-11">
              ПРИКЛАД:
            </span>
            <span class="font-size-14 font-weight-bold text-blue-darken-3">
              {{ journalSource.numberMaskPreview || '---' }}
            </span>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-divider class="mt-5 mb-4"></v-divider>
    <div>
      <div class="d-flex align-center justify-space-between mb-3">
        <span class="font-size-13 font-weight-bold d-block">
          Перелік можливих змінних
        </span>
        <v-btn
          border
          class="text-none"
          size="small"
          style="border-color: #ddd"
          variant="outlined"
          @click="showPlaceholders = !showPlaceholders">
          <span class="font-weight-medium"> Показати/Сховати </span>
        </v-btn>
      </div>
      <v-card
        v-show="showPlaceholders"
        :loading="$loading.isLoading('maskPlaceholders')"
        border
        color="grey-lighten-5"
        max-height="300px">
        <v-card-text class="overflow-y-auto" style="max-height: 300px">
          <div
            v-for="(maskPlaceholder, idx) in $directory.get('maskPlaceholders')"
            :key="idx"
            class="d-flex align-center ga-1 pa-1">
            <v-chip color="grey" density="compact" rounded="lg" size="small">
              <span class="font-size-12 font-weight-bold text-blue-darken-3">
                {{ maskPlaceholder.id }}
              </span>
            </v-chip>
            <span class="font-size-12 text-disabled">
              {{ maskPlaceholder.name }}
            </span>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script lang="ts">
import { useRegistrationJournal } from '../registrationJournal'
import { confirm, setSnackbar } from 'best-modules/plugins'
import { fillDirectory } from '@/directory'
import { ref } from 'vue'
import { openDialog } from '@/dialog'
import { registrationJournalMaskDelete } from '@/requests/registrationJournal'

export default {
  name: 'JournalMask',
  setup() {
    const { journalSource, journalId } = useRegistrationJournal()
    const showPlaceholders = ref(false)
    fillDirectory('maskPlaceholders')

    const createMask = () => {
      return openDialog({
        name: 'MaskPlaceholder',
        action: 'create',
        dialogData: {
          journalId: journalId.value,
          journalCode: journalSource.code,
        },
        params: {
          title: 'Маска реєстраційного номера (створення)',
          subtitle: 'Налаштуйте шаблон автоматичної нумерації',
          cb: res => {
            journalSource.numberMask = res.numberMask
            journalSource.maskName = res.maskName
            journalSource.maskDescription = res.maskDescription
            journalSource.numberMaskPreview = res.numberMaskPreview
          },
        },
      })
    }

    const deleteMask = () => {
      return confirm({
        text: 'Ви впевнені, що хочете видалити цю маску?',
      }).then(() => {
        return registrationJournalMaskDelete(journalId.value).then(() => {
          journalSource.numberMask = ''
          journalSource.numberMaskPreview = ''
          journalSource.maskDescription = ''
          setSnackbar({ text: 'Маску видалено' })
        })
      })
    }

    return {
      deleteMask,
      journalSource,
      showPlaceholders,
      createMask,
    }
  },
}
</script>

<style lang="scss" scoped></style>
